<template>
  <div class="form-group row">
    <label class="col-4 col-form-label text-right">
      <em v-if="required" style="color: red;">*</em>
      {{ label }}
    </label>
    <div class="col-6">
      <!--
      <select class="form-control" :class="{ 'is-valid': !hasError, 'is-invalid': hasError }" v-model="selected" @change="change()" :name="label" v-validate.initial="validate" :disabled="disabled">
      -->
      <select class="form-control" v-model="selected" @change="change()" :name="label" :disabled="disabled">
        <option v-for='info of mappedList' :value="info.value">{{ info.key }}</option>
      </select>
      <div v-if="!!note" class="text-warning">
        {{ note }}
      </div>
      <div v-if="!!invalidFeedback" class="invalid-feedback" v-show="hasError">
        {{ invalidFeedback }}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        selected: ''
      }
    },
    props: {
      label: {
        required: false,
        default: '',
        type: String
      },
      value: {
      },
      list: { // [ v1, v2, ... ] or [ {key: k1, value: v1}, ... ]
        required: true,
        type: Array
      },
      note: {
        required: false,
        type: String,
        default: null
      },
      validate: {
        required: false,
        type: [ Object, String ],
        default: 'required'
      },
      invalidFeedback: {
        required: false,
        type: String,
        default: null
      },
      required: {
        required: false,
        type: Boolean,
        default: true
      },
      disabled: {
        required: false,
        type: Boolean,
        default: false
      }
    },
    methods: {
      change () {
        this.$emit('input', this.selected)
      }
    },
    computed: {
      mappedList () {
        var list = []

        this.selected = this.value

        this.list.forEach(value => {
          if (typeof value === 'object') {
            list.push(value)
          } else {
            list.push({
              key: value,
              value
            })
          }
        })

        return list
      },
      hasError () {
        return this.errors.has(this.label)
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/utils/select-field.vue